<template>
  <div class="game-buddy-booking-container">
    <el-card class="booking-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span>陪玩预约</span>
      </div>
      
      <div v-if="gameBuddy" class="booking-content">
        <div class="game-buddy-detail">
          <h3>陪玩选手信息</h3>
          <el-divider />
          <p><strong>选手ID：</strong>{{ gameBuddy.id }}</p>
          <p><strong>游戏专长：</strong>{{ gameBuddy.expertise }}</p>
          <p><strong>自我介绍：</strong>{{ gameBuddy.introduction }}</p>
        </div>
        
        <el-divider />
        
        <div class="booking-form">
          <h3>预约信息</h3>
          <el-divider />
          <el-form :model="bookingForm" :rules="rules" ref="bookingForm" label-width="120px">
            <el-form-item label="预约日期" prop="bookingDate">
              <el-date-picker
                v-model="bookingForm.bookingDate"
                type="date"
                placeholder="选择预约日期"
                style="width: 100%;"
                :disabled-date="disabledDate"
              ></el-date-picker>
            </el-form-item>
            <el-form-item label="开始时间" prop="startTime">
              <el-time-picker
                v-model="bookingForm.startTime"
                format="HH:mm"
                placeholder="选择开始时间"
                style="width: 100%;"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="结束时间" prop="endTime">
              <el-time-picker
                v-model="bookingForm.endTime"
                format="HH:mm"
                placeholder="选择结束时间"
                style="width: 100%;"
              ></el-time-picker>
            </el-form-item>
            <el-form-item label="备注信息" prop="note">
              <el-input
                v-model="bookingForm.note"
                type="textarea"
                placeholder="请输入备注信息（可选）"
                rows="3"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitBooking" :loading="loading">提交预约</el-button>
              <el-button @click="resetForm">重置</el-button>
              <el-button @click="goBack">返回列表</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <div v-else class="loading-state">
        <el-empty description="加载中..."></el-empty>
      </div>
    </el-card>
  </div>
</template>

<script>

export default {
  name: 'GameBuddyBooking',
  data() {
    return {
      loading: false,
      gameBuddyId: null,
      gameBuddy: null,
      bookingForm: {
        userId: null,
        gameBuddyId: null,
        bookingDate: '',
        startTime: '',
        endTime: '',
        note: ''
      },
      rules: {
        bookingDate: [
          { required: true, message: '请选择预约日期', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endTime: [
          { required: true, message: '请选择结束时间', trigger: 'change' },
          { validator: this.validateEndTime, trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    // 从路由参数获取陪玩选手ID
    this.gameBuddyId = this.$route.query.gameBuddyId
    if (this.gameBuddyId) {
      this.loadGameBuddyDetail()
    } else {
      this.$message.error('请选择陪玩选手')
      this.goBack()
    }
    
    // 从localStorage获取当前用户ID
    const user = JSON.parse(localStorage.getItem('user'))
    console.log('Retrieved user from localStorage:', user)
    if (user) {
      this.bookingForm.userId = user.id
      console.log('Set userId in booking form:', this.bookingForm.userId)
    } else {
      console.error('No user found in localStorage!')
      // Fallback for testing - use player1's ID
      this.bookingForm.userId = 2
      console.log('Using fallback userId:', this.bookingForm.userId)
    }
  },
  methods: {
    loadGameBuddyDetail() {
      this.$axios.get(`/game-buddy/detail/${this.gameBuddyId}`)
          .then(response => {
            this.gameBuddy = response.data.data
            this.bookingForm.gameBuddyId = this.gameBuddy.id
          })
          .catch(error => {
            this.$message.error('加载陪玩选手信息失败')
            console.error('Load game buddy detail error:', error)
          })
    },
    disabledDate(time) {
      // 只能选择今天及以后的日期
      return time.getTime() < Date.now() - 8.64e7
    },
    validateEndTime(rule, value, callback) {
      if (this.bookingForm.startTime && value) {
        const start = new Date(`2000-01-01T${this.bookingForm.startTime}`)
        const end = new Date(`2000-01-01T${value}`)
        if (end <= start) {
          callback(new Error('结束时间必须晚于开始时间'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    },
    submitBooking() {
      this.$refs.bookingForm.validate((valid) => {
        if (valid) {
          this.loading = true
          // 格式化日期
          const formattedDate = new Date(this.bookingForm.bookingDate).toISOString().split('T')[0]
          this.bookingForm.bookingDate = formattedDate
          
          this.$axios.post('/game-buddy/booking/create', this.bookingForm)
            .then(response => {
              this.$message.success('预约提交成功，请等待陪玩选手确认')
              this.$router.push('/game-buddy-list')
            })
            .catch(error => {
              this.$message.error('预约提交失败，请重试')
              console.error('Submit booking error:', error)
            })
            .finally(() => {
              this.loading = false
            })
        }
      })
    },
    resetForm() {
      this.$refs.bookingForm.resetFields()
      this.bookingForm.gameBuddyId = this.gameBuddy.id
      this.bookingForm.userId = JSON.parse(localStorage.getItem('user')).id
    },
    goBack() {
      this.$router.push('/game-buddy-list')
    }
  }
}
</script>

<style scoped>
.game-buddy-booking-container {
  padding: 20px 0;
}

.booking-card {
  margin-bottom: 20px;
}

.booking-content {
  display: flex;
  flex-direction: column;
}

.game-buddy-detail {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.booking-form {
  margin-top: 20px;
}

.loading-state {
  text-align: center;
  padding: 50px 0;
}
</style>
